/**
 * 注册i18n
 * @param app
 */
import { createI18n } from '@/hooks/i18n/index';

import zhCN from '@/locales/zh-CN';
import enUS from '@/locales/en-US';

import { useLocaleStoreWithOut } from '@/store/modules/localeStore';
const messages = {
  'en-US': {
    ...enUS,
  },
  'zh-CN': {
    ...zhCN,
  },
};

export const languageMap = {
  'en-US': {
    label: 'English',
    key: 'en-US',
  },
  'zh-CN': {
    label: '简体中文',
    key: 'zh-CN',
  },
};
const localeStore = useLocaleStoreWithOut();
const I18n = createI18n({
  legacy: false,
  locale: localeStore.localInfo.locale || 'en-US', // set locale
  fallbackLocale: localeStore.localInfo.fallback || 'en-US', // set fallback locale
  messages, // set locale messages
  // If you need to specify other options, you can set other options
  // ...
});
export function setupi18n(app) {
  app.use(I18n);
}

export default I18n;
